import { UseFormReturn } from 'react-hook-form'
import { z } from 'zod'

import FormInput from '@/components/form/formInput'

// eslint-disable-next-line react-refresh/only-export-components
export const clientRefSchema = z.object({
    clientRef: z.string(),
})
type ClientRefSchemaType = z.infer<typeof clientRefSchema>

interface Props {
    form: UseFormReturn<ClientRefSchemaType>
}

export default function CreateOrderClientRefForm({ form }: Props) {
    return <FormInput control={form.control} name="clientRef" label="Client Reference" className="mt-4" />
}
